import { uiLanguages, loadLanguageAsync } from '@/i18n';

export default {
  data() {
    return {
      uiLangaugeLoading: false,
    };
  },

  methods: {
    openLanguageActionSheet() {
      let that = this;
      let buttonOptions = uiLanguages.map((uiLanguage) => uiLanguage.title);
      buttonOptions.push('Cancel');

      this.$ons.openActionSheet({
        title: 'Select Language',
        cancelable: true,
        buttons: buttonOptions
      }).then(function (index) {
        if (index >= 0 && index < uiLanguages.length) {
          that.changeUiLanguage(uiLanguages[index].code);
        }
      });
      return;
    },

    changeUiLanguage(uiLanguage) {
      loadLanguageAsync(uiLanguage);
      if (this.currentUser._is_guest) { return; }

      let that = this;
      this.uiLangaugeLoading = true;
      this.currentUser.updateUiLanguage(uiLanguage)
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          that.uiLangaugeLoading = false;
        });
    },
  },
};
